import { MapPin, Clock, DollarSign, CheckCircle, XCircle, View } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export interface Lead {
  id: string;
  name: string;
  project: string;
  location: string;
  budget: string;
  timeAgo: string;
  description: string;
}

interface IncomingLeadsProps {
  leads?: Lead[];
}

const defaultLeads: Lead[] = [
  {
    id: '1',
    name: 'Sarah Mitchell',
    project: 'Kitchen Remodel',
    location: 'Austin, TX',
    budget: '$25,000 - $35,000',
    timeAgo: '2 hours ago',
    description: 'Looking to remodel entire kitchen including cabinets, countertops, and appliances.'
  },
  {
    id: '2',
    name: 'David Chen',
    project: 'Bathroom Addition',
    location: 'Round Rock, TX',
    budget: '$18,000 - $22,000',
    timeAgo: '5 hours ago',
    description: 'Adding a second bathroom to existing home. Need full plumbing and tile work.'
  },
  {
    id: '3',
    name: 'Lisa Anderson',
    project: 'Deck Construction',
    location: 'Georgetown, TX',
    budget: '$12,000 - $15,000',
    timeAgo: '1 day ago',
    description: 'Build a 400 sq ft composite deck with stairs and railing.'
  }
];

export function IncomingLeads({ leads = defaultLeads }: IncomingLeadsProps) {
  const navigate = useNavigate()
  return (
    <div className="dashboard-panel leads-panel bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="font-[500] text-gray-900 tracking-tight">Open Leads</h3>
          <div className="text-sm text-gray-600 mt-1">{leads.length} new opportunities</div>
        </div>
        <div className="px-3 py-1.5 bg-indigo-50 rounded-lg">
          <span className="text-sm font-[500] text-indigo-600">{leads.length} New</span>
        </div>
      </div>

      <div className="space-y-3">
        {leads.map((lead) => (
          <div 
            key={lead.id}
            className="border border-gray-200 rounded-xl p-4 hover:border-indigo-200 hover:bg-indigo-50/30 transition-all duration-200"
          >
            <div className="flex items-start justify-between mb-3">
              <div className="flex-1">
                <h4 className="font-[500] text-gray-900 mb-1">{lead.name}</h4>
                <div className="text-sm text-gray-600 font-medium">{lead.project}</div>
              </div>
              <span className="text-xs text-gray-500 whitespace-nowrap ml-4">
                <Clock className="w-3 h-3 inline mr-1" />
                {lead.timeAgo}
              </span>
            </div>

            <div className="text-sm text-gray-600 mb-4 leading-relaxed">{lead.description}</div>

            <div className="flex items-center gap-4 mb-1 pb-4 border-b border-gray-100">
              <div className="flex items-center gap-1.5 text-sm text-gray-600">
                <MapPin className="w-4 h-4 text-gray-400" />
                <span>{lead.location}</span>
              </div>
              <div className="flex items-center gap-1.5 text-sm text-gray-600">
                <DollarSign className="w-4 h-4 text-gray-400" />
                <span>{lead.budget}</span>
              </div>
            </div>

            <div className="flex gap-3">
              <button onClick={()=>{
                navigate("/pages-projects")
              }}  className="flex-1 border-0 flex items-center justify-center gap-2 bg-indigo-600 hover:bg-indigo-700 active:bg-indigo-800 text-white py-2.5 px-4 rounded-lg font-[500] transition-all duration-200 text-sm shadow-sm">
                View Lead
              </button>
         
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
